export enum DiscrepancyReason {
  FXLOSS = "fx-loss",
  FXGAIN = "fx-gain",
  DISCOUNT = "discount",
  EXACT_MATCH = "exact-match",
}
